/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Integration upgrade request
 * @export
 * @interface IntegrationUpgradeRequest
 */
export interface IntegrationUpgradeRequest {
    /**
     * 
     * @type {string}
     * @memberof IntegrationUpgradeRequest
     */
    targetVersionId?: string;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationUpgradeRequest
     */
    preserveConfiguration?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof IntegrationUpgradeRequest
     */
    forceUpgrade?: boolean;
}

/**
 * Check if a given object implements the IntegrationUpgradeRequest interface.
 */
export function instanceOfIntegrationUpgradeRequest(value: object): value is IntegrationUpgradeRequest {
    return true;
}

export function IntegrationUpgradeRequestFromJSON(json: any): IntegrationUpgradeRequest {
    return IntegrationUpgradeRequestFromJSONTyped(json, false);
}

export function IntegrationUpgradeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): IntegrationUpgradeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'targetVersionId': json['targetVersionId'] == null ? undefined : json['targetVersionId'],
        'preserveConfiguration': json['preserveConfiguration'] == null ? undefined : json['preserveConfiguration'],
        'forceUpgrade': json['forceUpgrade'] == null ? undefined : json['forceUpgrade'],
    };
}

export function IntegrationUpgradeRequestToJSON(json: any): IntegrationUpgradeRequest {
    return IntegrationUpgradeRequestToJSONTyped(json, false);
}

export function IntegrationUpgradeRequestToJSONTyped(value?: IntegrationUpgradeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'targetVersionId': value['targetVersionId'],
        'preserveConfiguration': value['preserveConfiguration'],
        'forceUpgrade': value['forceUpgrade'],
    };
}

